import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';

export class PerformanceOverviewService {
   async getPerformancesCustomers(query?: LocationQuery) {
      const response = await http.get(`/performances-customers`, {
         params: { ...query },
      });
      return response.data;
   }

   async getPerformancesOverview(query?: LocationQuery) {
      const response = await http.get(`/performances-overview`, {
         params: { ...query },
      });
      return response.data;
   }
}
